import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "@/lib/analytics";

// Fires a first-party pageview on every public route change (skips admin).
export default function AnalyticsTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    trackPageview(pathname);
  }, [pathname]);
  return null;
}
